import {ajaxClient} from "./ajaxClient.js";
import {ajaxMultipart} from "./ajaxMultipart.js";

export default {
    getAbortController() {
        return new AbortController();
    },
    get(url, abortCtrl) {
        return ajaxClient.get(url, ( abortCtrl ? {signal:abortCtrl.signal} : null ));
    },
    async post(url, payload, abortCtrl) {
        await ajaxClient.get("/sanctum/csrf-cookie");
        return ajaxClient.post(url, (payload ? payload : null), (abortCtrl ? {signal: abortCtrl.signal} : null));
    },
    async upload(url, payload, abortCtrl) {
        await ajaxMultipart.get("/sanctum/csrf-cookie");
        return ajaxMultipart.post(url, (payload ? payload : null), (abortCtrl ? {signal: abortCtrl.signal} : null));
    }
}
